import { useEffect } from "react";
import AmesHeroSection from "./components/HeroSection";
import AmesStickyNav from "./components/StickyNav";
import AmesProcessingTimeSection from "./components/ProcessingTimeSection";
import AmesServicesSection from "./components/ServicesSection";
import AmesLocalAreaSection from "./components/LocalAreaSection";
import AmesTestimonialsSection from "./components/TestimonialsSection";
import AmesAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AmesComparisonSection from "./components/ComparisonSection";
import AmesMistakesSection from "./components/MistakesSection";
import AmesHowItWorksSection from "./components/HowItWorksSection";
import AmesFAQSection, { faqs } from "./components/FAQSection";
import AmesHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AmesFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function AmesPage() {
  useEffect(() => {
    document.title = "Emergency Passport Ames IA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/ames/";

    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Ames, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Iowa State University students, Story County professionals, and central Iowa families.");
    setMeta("geo.placename", "Ames, Iowa");
    setMeta("geo.region", "US-IA");
    setMeta("geo.position", "42.0347;-93.6200");
    setMeta("ICBM", "42.0347, -93.6200");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "Iowa", item: "https://fastpassportcenter.com/iowa/" },
          { "@type": "ListItem", position: 3, name: "Ames Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for Ames, Iowa State University, and central Iowa. As fast as 24 hours.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Ames", containedInPlace: { "@type": "State", name: "Iowa" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    document.getElementById("structured-data")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <AmesHeroSection />
      <AmesStickyNav />
      <AmesProcessingTimeSection />
      <AmesServicesSection />
      <AmesLocalAreaSection />
      <AmesTestimonialsSection />
      <AmesAcceptanceFacilitiesSection />
      <AmesComparisonSection />
      <AmesMistakesSection />
      <AmesHowItWorksSection />
      <AmesFAQSection />
      <AmesHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/ames" state="IA" />
      <AmesFinalCTA />
    </div>
  );
}